export const splitProductTitle = (productTitle) => {
    let title;
    if (/multi/i.test(productTitle)) {
        title = productTitle.split(/ multi/i)[0];
    }
    else if (/canvas/i.test(productTitle)) {
        title = productTitle.split(/ canvas/i)[0];
    }
    else {
        title = productTitle.split(/ wall/i)[0];
    }
    const subtitle = productTitle.replace(title, '');
    return { title, subtitle };
};
